/**
 * Export Version Download Formatter.
 */
window.exportVersionDownloadFormatter = function(value, row) {
    let html = '';
    if (row.raw_status == "completed") {
        html += '<a href="/admin/exports/versions/download/'+row.id+'">';
        html += '<i class="fa fa-download"></i>';
        html += '</a>';
    }
    return html;
}
